import { render, staticRenderFns } from "./FirstInfoCard.vue?vue&type=template&id=78bfbb25&scoped=true&"
import script from "./FirstInfoCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./FirstInfoCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./FirstInfoCard.vue?vue&type=style&index=0&id=78bfbb25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bfbb25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78bfbb25')) {
      api.createRecord('78bfbb25', component.options)
    } else {
      api.reload('78bfbb25', component.options)
    }
    module.hot.accept("./FirstInfoCard.vue?vue&type=template&id=78bfbb25&scoped=true&", function () {
      api.rerender('78bfbb25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/about-us/index/components/MainContent/components/FirstInfoCard.vue"
export default component.exports